import { useCallback, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  closeConciergeWidget,
  openConciergeWidget,
  toggleConciergeWidget,
} from "../../redux/reducers/conciergeWidget";
import { useLocation } from "react-router-dom";

export const useConciergeWidget = () => {
  const isOpen = useAppSelector((state) => state.conciergeWidget.isOpen);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const prevLocation = useRef(location);

  const toggle = useCallback(() => {
    dispatch(toggleConciergeWidget());
  }, [dispatch]);

  const closeWidget = useCallback(() => {
    dispatch(closeConciergeWidget());
  }, [dispatch]);

  const openWidget = useCallback(() => {
    dispatch(openConciergeWidget());
  }, [dispatch]);

  useEffect(() => {
    if (location !== prevLocation.current) {
      closeWidget();
    }
    prevLocation.current = location;
  }, [location, closeWidget]);

  return {
    isOpen,
    toggle,
    closeWidget,
    openWidget,
  };
};
